import { Controller } from '@hotwired/stimulus'

/**
 * Controller for a filter dropdown
 *
 * This controller is responsible for managing the state of a filter dropdown and updating the filter params hash when the state changes (i.e. when a user selects or deselects a filter option)
 */
export default class FilterController extends Controller {
  static classes = ['active']
  static targets = ['activeElement']

  static values = {
    /**
     * Is this filter engaged as part of the current request?
     */
    active: Boolean,
  }

  connect() {
    this.calculateActiveValue()
  }

  /**
   * Calculate the active value based on the state of the filter inputs
   */
  calculateActiveValue() {
    let isActive = false

    this.element.querySelectorAll('input').forEach((input) => {
      if (input.checked) {
        isActive = true
        return
      }
    })

    this.activeValue = isActive
  }

  /**
   * Handle Change event on filter inputs
   */
  change(event) {
    this.calculateActiveValue()
  }

  /**
   * Handle active value change
   *
   * When active, add the value to the filter params array
   * When inactive, remove the value from the filter params array
   */
  activeValueChanged(value, prevValue) {
    const el = this.activeElementTarget || this.element

    if (value) {
      el.classList.add(this.activeClass)
    } else {
      el.classList.remove(this.activeClass)
    }
  }
}

